import { Fragment } from 'react'
import styled from 'styled-components'
import Modal from '../modal/Modal'

const Title = styled.h4`
    margin: 0;
    font-size: var(--font-M);
    font-weight: 600;
    color: ${({ theme }) => theme.font.color};
`

const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.5rem 1.25rem;
`

const FieldLabel = styled.span`
    font-size: var(--font-S);
    color: ${({ theme }) => theme.font.label};
    font-weight: 500;
    white-space: nowrap;
`

const FieldValue = styled.span`
    font-size: var(--font-S);
    color: ${({ theme }) => theme.font.color};
`

// ── Formatters ─────────────────────────────────────────────────────────────

const formatters = {
    datetime: (val) => {
        if (!val) return '—'
        const d = new Date(val)
        return d.toLocaleString('en-US', {
            weekday: 'short', month: 'short', day: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: false
        })
    },
    duration: (val) => {
        if (val == null) return '—'
        if (val < 60) return `${val} min`
        const h = Math.floor(val / 60)
        const m = val % 60
        return m > 0 ? `${h}h ${m}min` : `${h}h`
    }
}

const applyFormat = (val, format) => {
    if (format && formatters[format]) return formatters[format](val)
    return val != null ? String(val) : '—'
}

// ── Component ──────────────────────────────────────────────────────────────

const WorkPlannerOpInfoModal = ({ op, config, onClose }) => {
    if (!op || !config) return null

    // Build title from config.title array
    const title = (config.title ?? [])
        .map(({ key, suffix }) => {
            const val = op[key]
            return val != null ? `${val}${suffix ?? ''}` : ''
        })
        .join('')

    return (
        <Modal show onClose={onClose} setShow={(v) => { if (!v) onClose() }} minHeight="auto">
            <Modal.Header onClose={onClose}>
                <Title>{title}</Title>
            </Modal.Header>
            <Modal.Body>
                <InfoGrid>
                    {(config.fields ?? []).map((field) => {
                        const raw = op[field.key]
                        const isEmpty = raw == null || raw === ''
                        if (isEmpty && !field.required) return null
                        const display = isEmpty ? '—' : applyFormat(raw, field.format)
                        return (
                            <Fragment key={field.key}>
                                <FieldLabel>{field.label}</FieldLabel>
                                <FieldValue>{display}</FieldValue>
                            </Fragment>
                        )
                    })}
                </InfoGrid>
            </Modal.Body>
        </Modal>
    )
}

export default WorkPlannerOpInfoModal
